var _path, _rect, _path2, _path3, _rect2, _rect3, _path4, _rect4, _rect5, _rect6, _path5, _rect7, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeacherDashboardTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 263,
    viewBox: "0 0 363 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17C1 8.16344 8.16344 1 17 1H61C69.8366 1 77 8.16344 77 17V61C77 69.8366 69.8366 77 61 77H17C8.16344 77 1 69.8366 1 61V17Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 44,
    height: 44,
    rx: 8,
    fill: "#D9EDB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7608 43.3804C35.3466 43.3804 35.0108 43.7162 35.0108 44.1304C35.0108 44.5446 35.3466 44.8804 35.7608 44.8804V43.3804ZM42.9347 35.3152C43.349 35.3152 43.6847 34.9794 43.6847 34.5652C43.6847 34.151 43.349 33.8152 42.9347 33.8152V35.3152ZM38.5978 46.5217C38.5978 46.9359 38.9336 47.2717 39.3478 47.2717C39.762 47.2717 40.0978 46.9359 40.0978 46.5217H38.5978ZM40.0978 32.1739C40.0978 31.7597 39.762 31.4239 39.3478 31.4239C38.9336 31.4239 38.5978 31.7597 38.5978 32.1739H40.0978ZM49.3587 39.3478C49.3587 44.8766 44.8766 49.3587 39.3478 49.3587V50.8587C45.7051 50.8587 50.8587 45.7051 50.8587 39.3478H49.3587ZM39.3478 49.3587C33.8189 49.3587 29.3369 44.8766 29.3369 39.3478H27.8369C27.8369 45.7051 32.9905 50.8587 39.3478 50.8587V49.3587ZM29.3369 39.3478C29.3369 33.8189 33.8189 29.3369 39.3478 29.3369V27.8369C32.9905 27.8369 27.8369 32.9905 27.8369 39.3478H29.3369ZM39.3478 29.3369C44.8766 29.3369 49.3587 33.8189 49.3587 39.3478H50.8587C50.8587 32.9905 45.7051 27.8369 39.3478 27.8369V29.3369ZM38.1521 33.8152C37.6336 33.8152 36.8724 33.9646 36.2193 34.4348C35.528 34.9325 35.0108 35.7555 35.0108 36.9565H36.5108C36.5108 36.2444 36.7907 35.8717 37.0958 35.6521C37.4391 35.4049 37.8736 35.3152 38.1521 35.3152V33.8152ZM35.0108 36.9565C35.0108 38.1574 35.528 38.9804 36.2193 39.4782C36.8724 39.9484 37.6336 40.0978 38.1521 40.0978V38.5978C37.8736 38.5978 37.4391 38.5081 37.0958 38.2609C36.7907 38.0412 36.5108 37.6686 36.5108 36.9565H35.0108ZM38.1521 40.0978H40.5434V38.5978H38.1521V40.0978ZM40.5434 40.0978C40.822 40.0978 41.2565 40.1875 41.5998 40.4347C41.9048 40.6543 42.1847 41.027 42.1847 41.7391H43.6847C43.6847 40.5381 43.1675 39.7151 42.4762 39.2174C41.8232 38.7472 41.062 38.5978 40.5434 38.5978V40.0978ZM42.1847 41.7391C42.1847 42.4512 41.9048 42.8238 41.5998 43.0435C41.2565 43.2907 40.822 43.3804 40.5434 43.3804V44.8804C41.062 44.8804 41.8232 44.731 42.4762 44.2608C43.1675 43.763 43.6847 42.9401 43.6847 41.7391H42.1847ZM40.5434 43.3804H39.3478V44.8804H40.5434V43.3804ZM39.3478 43.3804H35.7608V44.8804H39.3478V43.3804ZM42.9347 33.8152H39.3478V35.3152H42.9347V33.8152ZM39.3478 33.8152H38.1521V35.3152H39.3478V33.8152ZM38.5978 44.1304V46.5217H40.0978V44.1304H38.5978ZM40.0978 34.5652V32.1739H38.5978V34.5652H40.0978Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H61V0H17V2ZM76 17V61H78V17H76ZM61 76H17V78H61V76ZM2 61V17H0V61H2ZM17 76C8.71573 76 2 69.2843 2 61H0C0 70.3888 7.61116 78 17 78V76ZM76 61C76 69.2843 69.2843 76 61 76V78C70.3888 78 78 70.3888 78 61H76ZM61 2C69.2843 2 76 8.71573 76 17H78C78 7.61116 70.3888 0 61 0V2ZM17 0C7.61116 0 0 7.61116 0 17H2C2 8.71573 8.71573 2 17 2V0Z",
    fill: "#EEF1FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 254.5,
    y: 161.5,
    width: 58,
    height: 58,
    rx: 16.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 267.029,
    y: 174.5,
    width: 32.9412,
    height: 32,
    rx: 8,
    fill: "#D2DAF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M284.41 190.753C284.41 190.394 284.119 190.103 283.76 190.103C283.401 190.103 283.11 190.394 283.11 190.753H284.41ZM283.11 194.231C283.11 194.59 283.401 194.881 283.76 194.881C284.119 194.881 284.41 194.59 284.41 194.231H283.11ZM290.125 197.033L289.704 196.538L289.704 196.538L290.125 197.033ZM277.394 197.033L277.815 196.538L277.815 196.538L277.394 197.033ZM290.125 186.212L290.546 185.717L290.546 185.717L290.125 186.212ZM277.394 186.212L276.973 185.717L276.973 185.717L277.394 186.212ZM284.41 192.492V190.753H283.11V192.492H284.41ZM283.11 192.492V194.231H284.41V192.492H283.11ZM283.76 191.842C282.011 191.842 280.294 191.628 279.045 191.222C278.417 191.018 277.951 190.779 277.658 190.529C277.374 190.288 277.298 190.083 277.303 189.904L276.004 189.863C275.982 190.554 276.332 191.109 276.816 191.52C277.291 191.923 277.934 192.228 278.642 192.458C280.065 192.921 281.928 193.142 283.76 193.142V191.842ZM283.76 193.142C285.591 193.142 287.455 192.921 288.877 192.458C289.585 192.228 290.229 191.923 290.703 191.52C291.187 191.109 291.538 190.554 291.516 189.863L290.216 189.904C290.222 190.083 290.145 190.288 289.862 190.529C289.568 190.779 289.103 191.018 288.475 191.222C287.226 191.628 285.509 191.842 283.76 191.842V193.142ZM290.271 191.623C290.271 192.946 290.173 194.181 290.03 195.117C289.958 195.586 289.876 195.967 289.795 196.239C289.754 196.376 289.717 196.473 289.687 196.534C289.651 196.61 289.649 196.585 289.704 196.538L290.546 197.528C290.701 197.397 290.798 197.224 290.86 197.095C290.928 196.952 290.988 196.787 291.04 196.612C291.145 196.261 291.238 195.817 291.315 195.314C291.47 194.305 291.571 193.004 291.571 191.623H290.271ZM289.704 196.538C289.752 196.498 289.762 196.508 289.656 196.545C289.569 196.575 289.442 196.61 289.273 196.646C288.936 196.719 288.475 196.79 287.915 196.852C286.798 196.976 285.33 197.059 283.76 197.059V198.359C285.372 198.359 286.888 198.274 288.058 198.144C288.642 198.079 289.151 198.003 289.548 197.917C289.745 197.874 289.926 197.827 290.08 197.774C290.215 197.727 290.399 197.653 290.546 197.528L289.704 196.538ZM283.76 197.059C282.189 197.059 280.721 196.976 279.604 196.852C279.045 196.79 278.584 196.719 278.246 196.646C278.077 196.61 277.951 196.575 277.864 196.545C277.758 196.508 277.768 196.498 277.815 196.538L276.973 197.528C277.12 197.653 277.304 197.727 277.439 197.774C277.593 197.827 277.774 197.874 277.972 197.917C278.368 198.003 278.877 198.079 279.461 198.144C280.632 198.274 282.148 198.359 283.76 198.359V197.059ZM277.815 196.538C277.87 196.585 277.868 196.61 277.832 196.534C277.803 196.473 277.766 196.376 277.725 196.239C277.643 195.967 277.562 195.586 277.49 195.117C277.346 194.181 277.249 192.946 277.249 191.623H275.949C275.949 193.004 276.05 194.305 276.205 195.314C276.282 195.817 276.374 196.261 276.479 196.612C276.532 196.787 276.591 196.952 276.659 197.095C276.721 197.224 276.819 197.397 276.973 197.528L277.815 196.538ZM281.115 186.265C281.926 186.215 282.825 186.186 283.76 186.186V184.886C282.798 184.886 281.872 184.916 281.034 184.968L281.115 186.265ZM283.76 186.186C284.694 186.186 285.594 186.215 286.405 186.265L286.485 184.968C285.647 184.916 284.721 184.886 283.76 184.886V186.186ZM290.546 185.717C290.385 185.58 290.173 185.508 290.044 185.468C289.886 185.419 289.7 185.376 289.508 185.338C289.121 185.262 288.656 185.196 288.215 185.142C287.772 185.088 287.342 185.045 287.025 185.015C286.866 185 286.734 184.989 286.642 184.981C286.596 184.977 286.56 184.974 286.535 184.972C286.522 184.971 286.513 184.97 286.506 184.969C286.503 184.969 286.501 184.969 286.499 184.969C286.498 184.969 286.497 184.969 286.497 184.969C286.497 184.969 286.496 184.969 286.496 184.969C286.496 184.969 286.496 184.969 286.496 184.969C286.496 184.969 286.496 184.969 286.445 185.617C286.394 186.265 286.394 186.265 286.394 186.265C286.394 186.265 286.394 186.265 286.394 186.265C286.395 186.265 286.395 186.265 286.395 186.265C286.395 186.265 286.396 186.265 286.396 186.265C286.398 186.265 286.4 186.265 286.403 186.265C286.409 186.266 286.418 186.267 286.429 186.267C286.453 186.269 286.488 186.272 286.532 186.276C286.621 186.284 286.749 186.295 286.904 186.309C287.214 186.338 287.63 186.38 288.057 186.433C288.486 186.485 288.916 186.547 289.257 186.614C289.428 186.648 289.564 186.68 289.661 186.71C289.788 186.75 289.766 186.76 289.704 186.707L290.546 185.717ZM277.815 186.707C277.753 186.76 277.731 186.75 277.858 186.71C277.955 186.68 278.091 186.648 278.263 186.614C278.604 186.547 279.033 186.485 279.463 186.433C279.89 186.38 280.306 186.338 280.616 186.309C280.771 186.295 280.899 186.284 280.988 186.276C281.032 186.272 281.067 186.269 281.09 186.267C281.102 186.267 281.111 186.266 281.117 186.265C281.12 186.265 281.122 186.265 281.123 186.265C281.124 186.265 281.124 186.265 281.125 186.265C281.125 186.265 281.125 186.265 281.125 186.265C281.125 186.265 281.125 186.265 281.125 186.265C281.125 186.265 281.125 186.265 281.074 185.617C281.024 184.969 281.024 184.969 281.023 184.969C281.023 184.969 281.023 184.969 281.023 184.969C281.023 184.969 281.023 184.969 281.023 184.969C281.022 184.969 281.022 184.969 281.021 184.969C281.019 184.969 281.016 184.969 281.013 184.969C281.007 184.97 280.997 184.971 280.985 184.972C280.96 184.974 280.924 184.977 280.878 184.981C280.785 184.989 280.654 185 280.495 185.015C280.177 185.045 279.748 185.088 279.305 185.142C278.864 185.196 278.398 185.262 278.011 185.338C277.819 185.376 277.634 185.419 277.475 185.468C277.347 185.508 277.135 185.58 276.973 185.717L277.815 186.707ZM277.249 191.623C277.249 191.034 277.268 190.462 277.302 189.925L276.005 189.842C275.969 190.406 275.949 191.006 275.949 191.623H277.249ZM277.302 189.925C277.362 188.986 277.467 188.164 277.591 187.556C277.653 187.25 277.717 187.013 277.777 186.847C277.807 186.764 277.832 186.71 277.848 186.68C277.869 186.642 277.862 186.667 277.815 186.707L276.973 185.717C276.849 185.822 276.765 185.951 276.709 186.053C276.649 186.162 276.598 186.283 276.554 186.406C276.465 186.653 276.386 186.957 276.317 187.297C276.178 187.978 276.067 188.861 276.005 189.842L277.302 189.925ZM289.704 186.707C289.657 186.667 289.651 186.642 289.671 186.68C289.688 186.71 289.713 186.764 289.743 186.847C289.802 187.013 289.867 187.25 289.929 187.556C290.053 188.164 290.157 188.986 290.217 189.925L291.515 189.842C291.452 188.861 291.341 187.978 291.203 187.297C291.134 186.957 291.055 186.653 290.966 186.406C290.921 186.283 290.87 186.162 290.81 186.053C290.754 185.951 290.67 185.822 290.546 185.717L289.704 186.707ZM290.217 189.925C290.252 190.462 290.271 191.034 290.271 191.623H291.571C291.571 191.006 291.551 190.406 291.515 189.842L290.217 189.925ZM287.095 184.666C287.095 184.173 286.977 183.742 286.738 183.383C286.502 183.027 286.177 182.788 285.834 182.628C285.176 182.322 284.379 182.277 283.76 182.277V183.577C284.36 183.577 284.906 183.63 285.285 183.807C285.462 183.889 285.58 183.988 285.656 184.103C285.73 184.215 285.795 184.387 285.795 184.666H287.095ZM283.76 182.277C283.141 182.277 282.343 182.322 281.685 182.628C281.343 182.788 281.018 183.027 280.781 183.383C280.543 183.742 280.424 184.173 280.424 184.666H281.724C281.724 184.387 281.789 184.215 281.864 184.103C281.94 183.988 282.057 183.889 282.234 183.807C282.614 183.63 283.159 183.577 283.76 183.577V182.277ZM280.424 184.666V185.617H281.724V184.666H280.424ZM285.795 184.666V185.617H287.095V184.666H285.795Z",
    fill: "#4A5FDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 254.5,
    y: 161.5,
    width: 58,
    height: 58,
    rx: 16.5,
    stroke: "#EEF1FE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 311.5,
    y: 75.5,
    width: 37,
    height: 37,
    rx: 8.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 319.706,
    y: 84,
    width: 20.5882,
    height: 20,
    rx: 4,
    fill: "#F5C7D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M331.926 96.6987C332.129 96.961 332.505 97.0095 332.768 96.807C333.03 96.6045 333.078 96.2277 332.876 95.9654L331.926 96.6987ZM327.45 95.9654C327.248 96.2277 327.296 96.6045 327.559 96.807C327.821 97.0095 328.198 96.961 328.4 96.6987L327.45 95.9654ZM331.841 91.9277C331.51 91.9277 331.241 92.1963 331.241 92.5277C331.241 92.8591 331.51 93.1277 331.841 93.1277V91.9277ZM331.847 93.1277C332.178 93.1277 332.447 92.8591 332.447 92.5277C332.447 92.1963 332.178 91.9277 331.847 91.9277V93.1277ZM328.485 91.9277C328.153 91.9277 327.885 92.1963 327.885 92.5277C327.885 92.8591 328.153 93.1277 328.485 93.1277V91.9277ZM328.49 93.1277C328.822 93.1277 329.09 92.8591 329.09 92.5277C329.09 92.1963 328.822 91.9277 328.49 91.9277V93.1277ZM332.401 96.3321C332.876 95.9654 332.876 95.9652 332.876 95.965C332.876 95.9649 332.875 95.9647 332.875 95.9646C332.875 95.9643 332.875 95.964 332.875 95.9637C332.874 95.9631 332.874 95.9624 332.873 95.9616C332.872 95.9601 332.87 95.9583 332.869 95.9562C332.865 95.9521 332.861 95.9469 332.856 95.9408C332.846 95.9286 332.833 95.9125 332.816 95.8931C332.783 95.8543 332.735 95.8021 332.675 95.7409C332.555 95.6189 332.379 95.4587 332.153 95.2985C331.701 94.9796 331.023 94.6451 330.163 94.6451V95.8451C330.702 95.8451 331.142 96.054 331.46 96.2786C331.618 96.3902 331.74 96.5017 331.821 96.5836C331.861 96.6243 331.89 96.6569 331.908 96.6776C331.917 96.6879 331.923 96.6952 331.926 96.6989C331.928 96.7007 331.928 96.7017 331.928 96.7017C331.928 96.7017 331.928 96.7015 331.928 96.701C331.928 96.7007 331.927 96.7004 331.927 96.7C331.927 96.6999 331.927 96.6996 331.927 96.6994C331.926 96.6993 331.926 96.6991 331.926 96.6991C331.926 96.6989 331.926 96.6987 332.401 96.3321ZM330.163 94.6451C329.303 94.6451 328.625 94.9796 328.173 95.2985C327.947 95.4587 327.771 95.6189 327.651 95.7409C327.591 95.8021 327.544 95.8543 327.51 95.8931C327.493 95.9125 327.48 95.9286 327.47 95.9408C327.465 95.9469 327.461 95.9521 327.458 95.9562C327.456 95.9583 327.454 95.9601 327.453 95.9616C327.453 95.9624 327.452 95.9631 327.452 95.9637C327.451 95.964 327.451 95.9643 327.451 95.9646C327.451 95.9647 327.451 95.9649 327.451 95.965C327.45 95.9652 327.45 95.9654 327.925 96.3321C328.4 96.6987 328.4 96.6989 328.4 96.6991C328.4 96.6991 328.4 96.6993 328.4 96.6994C328.399 96.6996 328.399 96.6999 328.399 96.7C328.399 96.7004 328.399 96.7007 328.398 96.701C328.398 96.7015 328.398 96.7017 328.398 96.7017C328.398 96.7017 328.399 96.7007 328.4 96.6989C328.403 96.6952 328.409 96.6879 328.418 96.6776C328.436 96.6569 328.465 96.6243 328.505 96.5836C328.586 96.5017 328.708 96.3902 328.866 96.2786C329.184 96.054 329.624 95.8451 330.163 95.8451V94.6451ZM334.598 94.1581C334.598 96.5119 332.629 98.4495 330.163 98.4495V99.6495C333.259 99.6495 335.798 97.2072 335.798 94.1581H334.598ZM330.163 98.4495C327.697 98.4495 325.728 96.5119 325.728 94.1581H324.528C324.528 97.2072 327.067 99.6495 330.163 99.6495V98.4495ZM325.728 94.1581C325.728 91.8044 327.697 89.8668 330.163 89.8668V88.6668C327.067 88.6668 324.528 91.1091 324.528 94.1581H325.728ZM330.163 89.8668C332.629 89.8668 334.598 91.8044 334.598 94.1581H335.798C335.798 91.1091 333.259 88.6668 330.163 88.6668V89.8668ZM331.841 93.1277H331.847V91.9277H331.841V93.1277ZM328.485 93.1277H328.49V91.9277H328.485V93.1277Z",
    fill: "#EC6F86"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 311.5,
    y: 75.5,
    width: 37,
    height: 37,
    rx: 8.5,
    stroke: "#EEF1FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2924_189316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.596 208.176L64.8347 130.382C63.0701 129.12 62.6627 126.666 63.9248 124.901L104.53 68.1317C105.793 66.3671 108.246 65.9597 110.011 67.2218L218.772 145.016C220.537 146.278 220.944 148.732 219.682 150.497L179.077 207.266C177.815 209.031 175.361 209.438 173.596 208.176Z",
    fill: "url(#paint0_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.798 204.295L68.7657 129.884C67.1013 128.693 66.7172 126.378 67.9077 124.714L105.64 71.961C106.831 70.2966 109.145 69.9125 110.81 71.103L214.842 145.515C216.507 146.705 216.891 149.02 215.7 150.684L177.967 203.437C176.777 205.102 174.463 205.486 172.798 204.295Z",
    fill: "url(#paint1_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.494 159.71C193.16 155.895 191.929 148.478 195.744 143.144C195.901 142.925 196.064 142.713 196.232 142.508C197.042 141.524 196.853 140.064 195.817 139.323L122.817 87.1074C121.781 86.3662 120.338 86.6593 119.668 87.743C119.529 87.9687 119.381 88.1915 119.224 88.4105C115.409 93.7446 107.992 94.9759 102.658 91.1603C102.652 91.1557 102.645 91.1512 102.639 91.1466C101.639 90.4279 100.252 90.6282 99.5361 91.63L84.5498 112.581C83.8332 113.583 84.0917 114.96 85.0948 115.675C85.101 115.679 85.1073 115.684 85.1139 115.688C90.448 119.503 91.6788 126.92 87.8637 132.254C87.707 132.473 87.544 132.685 87.3757 132.89C86.5663 133.874 86.755 135.334 87.7913 136.076L160.791 188.29C161.827 189.032 163.27 188.739 163.94 187.654C164.079 187.429 164.227 187.206 164.384 186.987C168.199 181.653 175.616 180.422 180.95 184.237C180.956 184.242 180.962 184.246 180.969 184.251C181.969 184.969 183.356 184.769 184.072 183.767L199.059 162.816C199.775 161.814 199.517 160.437 198.514 159.723C198.506 159.719 198.5 159.714 198.494 159.71Z",
    fill: "url(#paint2_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.804 164.749C156.743 164.749 168.854 152.639 168.854 137.699C168.854 122.76 156.743 110.649 141.804 110.649C126.865 110.649 114.754 122.76 114.754 137.699C114.754 152.639 126.865 164.749 141.804 164.749Z",
    fill: "url(#paint3_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.944 130.595C159.983 129.832 159.647 128.933 158.931 127.897C158.159 126.78 157.232 125.735 156.158 124.756C156.123 124.671 156.085 124.59 156.041 124.514L155.635 121.408C155.505 121.012 155.284 120.701 154.968 120.476C154.624 120.23 154.257 120.119 153.87 120.146C153.483 120.172 153.197 120.314 153.012 120.573L152.119 121.82C149.61 120.417 147.113 119.801 144.626 119.973C142.138 120.146 140.003 121.479 138.221 123.971C137.586 124.858 137.107 125.739 136.786 126.613C136.464 127.487 136.339 128.36 136.409 129.233C136.479 130.105 136.583 130.883 136.723 131.567C136.724 131.572 136.726 131.577 136.727 131.582C136.727 131.582 138.267 140.865 138.268 140.869C138.28 140.959 138.294 141.045 138.306 141.132L133.157 148.331C131.947 147.335 131.063 146.205 130.504 144.94C129.945 143.675 129.569 142.595 129.373 141.697C129.177 140.799 128.91 140.229 128.57 139.986C128.056 139.618 127.405 139.564 126.617 139.823C125.828 140.081 125.24 140.483 124.851 141.026C124.229 141.896 124.106 143.104 124.482 144.65L129.83 176.872L172.717 207.547L159.944 130.595Z",
    fill: "url(#paint4_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.851 141.027C125.24 140.483 125.829 140.081 126.617 139.823C127.406 139.565 128.056 139.618 128.57 139.986C128.911 140.23 129.178 140.8 129.374 141.697C129.569 142.595 129.946 143.676 130.505 144.941C131.063 146.206 131.948 147.336 133.158 148.331L140.376 138.239C139.741 137.309 139.26 136.585 138.934 136.071C138.608 135.557 138.193 134.848 137.689 133.947C137.184 133.046 136.862 132.252 136.723 131.568C136.584 130.884 136.479 130.106 136.409 129.233C136.339 128.361 136.464 127.488 136.786 126.614C137.107 125.74 137.586 124.86 138.221 123.972C140.003 121.48 142.138 120.146 144.626 119.974C147.113 119.801 149.61 120.417 152.119 121.821L153.012 120.573C153.196 120.315 153.482 120.173 153.87 120.146C154.257 120.12 154.624 120.23 154.968 120.476C155.283 120.701 155.505 121.012 155.635 121.408C155.763 121.804 155.736 122.131 155.551 122.389L154.72 123.551C156.428 124.86 157.831 126.308 158.93 127.896C160.028 129.484 160.238 130.751 159.561 131.698C159.192 132.214 158.633 132.627 157.886 132.939C157.139 133.25 156.475 133.199 155.896 132.785C155.668 132.622 155.213 131.928 154.535 130.705C153.855 129.482 152.973 128.417 151.887 127.51L145.649 136.232C146.483 137.478 147.14 138.564 147.619 139.492C148.098 140.419 148.514 141.527 148.864 142.817C149.215 144.106 149.23 145.426 148.91 146.777C148.59 148.128 147.929 149.506 146.926 150.909C145.092 153.472 142.935 155.009 140.456 155.521C137.977 156.032 135.415 155.604 132.771 154.235L131.743 155.673C131.562 155.927 131.264 156.054 130.85 156.057C130.436 156.059 130.072 155.947 129.756 155.722C129.412 155.476 129.188 155.166 129.085 154.796C128.982 154.424 129.022 154.111 129.203 153.857L130.14 152.548C127.664 150.734 125.957 148.649 125.018 146.294C124.079 143.94 124.024 142.184 124.851 141.027ZM142.789 126.59C141.99 127.707 141.728 128.808 142.005 129.892C142.28 130.977 142.929 132.275 143.953 133.785L149.549 125.962C146.519 124.315 144.266 124.525 142.789 126.59ZM135.5 149.877C138.352 151.224 140.629 150.71 142.329 148.334C143.23 147.074 143.606 145.85 143.458 144.663C143.31 143.475 142.818 142.192 141.982 140.815L135.5 149.877Z",
    fill: "url(#paint5_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.076 89.9772C112.178 89.9772 114.693 87.4627 114.693 84.3608C114.693 81.259 112.178 78.7445 109.076 78.7445C105.974 78.7445 103.46 81.259 103.46 84.3608C103.46 87.4627 105.974 89.9772 109.076 89.9772Z",
    fill: "url(#paint6_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.856 157.056C205.958 157.056 208.473 154.541 208.473 151.439C208.473 148.337 205.958 145.823 202.856 145.823C199.754 145.823 197.239 148.337 197.239 151.439C197.239 154.541 199.754 157.056 202.856 157.056Z",
    fill: "url(#paint7_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7521 129.575C83.8539 129.575 86.3684 127.061 86.3684 123.959C86.3684 120.857 83.8539 118.343 80.7521 118.343C77.6503 118.343 75.1357 120.857 75.1357 123.959C75.1357 127.061 77.6503 129.575 80.7521 129.575Z",
    fill: "url(#paint8_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.532 196.654C177.634 196.654 180.149 194.139 180.149 191.037C180.149 187.935 177.634 185.42 174.532 185.42C171.43 185.42 168.915 187.935 168.915 191.037C168.915 194.139 171.43 196.654 174.532 196.654Z",
    fill: "url(#paint9_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.854 206.849L91.8223 96.8485C90.5885 95.0635 91.0354 92.6164 92.8203 91.3831L150.237 51.6975C152.022 50.4637 154.469 50.9106 155.702 52.6956L231.734 162.697C232.967 164.482 232.52 166.929 230.735 168.162L173.319 207.848C171.534 209.081 169.088 208.634 167.854 206.849Z",
    fill: "url(#paint10_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.415 202.927L95.6898 97.709C94.5263 96.0255 94.9478 93.7176 96.6309 92.5541L149.985 55.6761C151.669 54.5126 153.976 54.9341 155.14 56.6172L227.866 161.835C229.029 163.519 228.608 165.827 226.924 166.99L173.57 203.868C171.887 205.032 169.579 204.61 168.415 202.927Z",
    fill: "url(#paint11_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.68 169.663C203.951 164.268 205.301 156.872 210.696 153.143C210.918 152.99 211.143 152.846 211.371 152.71C212.465 152.058 212.782 150.62 212.057 149.572L161.025 75.7404C160.301 74.6924 158.844 74.4796 157.847 75.2732C157.64 75.4386 157.425 75.5978 157.203 75.7508C151.808 79.4795 144.413 78.1289 140.684 72.7341C140.679 72.7279 140.675 72.7213 140.671 72.715C139.972 71.7003 138.6 71.4197 137.587 72.1202L116.396 86.7669C115.383 87.4673 115.16 88.8503 115.863 89.8621C115.867 89.8683 115.872 89.875 115.876 89.8812C119.605 95.276 118.254 102.672 112.859 106.401C112.638 106.554 112.413 106.699 112.185 106.834C111.09 107.486 110.774 108.925 111.499 109.973L162.53 183.804C163.255 184.852 164.712 185.065 165.709 184.271C165.916 184.106 166.131 183.946 166.353 183.793C171.747 180.064 179.143 181.415 182.872 186.81C182.877 186.816 182.881 186.823 182.886 186.829C183.584 187.843 184.956 188.124 185.97 187.424L207.16 172.777C208.173 172.077 208.396 170.694 207.693 169.682C207.688 169.675 207.684 169.669 207.68 169.663Z",
    fill: "url(#paint12_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.777 156.822C176.717 156.822 188.827 144.711 188.827 129.772C188.827 114.833 176.717 102.722 161.777 102.722C146.838 102.722 134.728 114.833 134.728 129.772C134.728 144.711 146.838 156.822 161.777 156.822Z",
    fill: "url(#paint13_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.251 129.224C181.547 128.519 181.534 127.559 181.211 126.342C180.862 125.03 180.344 123.733 179.664 122.448C179.661 122.357 179.652 122.267 179.636 122.181L180.305 119.121C180.317 118.705 180.213 118.337 179.992 118.018C179.752 117.67 179.444 117.442 179.071 117.336C178.697 117.23 178.38 117.267 178.119 117.448L176.856 118.32C174.971 116.15 172.828 114.726 170.429 114.047C168.03 113.368 165.57 113.9 163.049 115.642C162.152 116.263 161.404 116.93 160.806 117.644C160.207 118.357 159.794 119.136 159.565 119.981C159.335 120.825 159.17 121.593 159.071 122.284C159.07 122.289 159.069 122.294 159.069 122.299C159.069 122.299 157.378 131.555 157.378 131.56C157.359 131.649 157.342 131.734 157.325 131.82L150.044 136.852C149.242 135.506 148.792 134.144 148.695 132.764C148.596 131.385 148.608 130.241 148.727 129.329C148.847 128.419 148.788 127.791 148.55 127.447C148.191 126.928 147.597 126.657 146.767 126.633C145.938 126.61 145.248 126.789 144.698 127.169C143.819 127.777 143.294 128.872 143.125 130.453L137.258 162.586L167.238 205.961L181.251 129.224Z",
    fill: "url(#paint14_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.699 127.169C145.249 126.789 145.939 126.61 146.768 126.633C147.597 126.657 148.192 126.928 148.55 127.447C148.788 127.791 148.847 128.419 148.728 129.329C148.608 130.241 148.597 131.385 148.695 132.764C148.793 134.144 149.243 135.506 150.044 136.852L160.252 129.797C159.968 128.707 159.761 127.863 159.628 127.269C159.495 126.675 159.344 125.868 159.175 124.849C159.005 123.83 158.97 122.974 159.071 122.284C159.171 121.593 159.336 120.824 159.565 119.981C159.794 119.136 160.207 118.357 160.806 117.644C161.404 116.93 162.152 116.263 163.05 115.642C165.57 113.9 168.03 113.368 170.43 114.047C172.828 114.726 174.971 116.15 176.857 118.32L178.119 117.448C178.38 117.267 178.697 117.23 179.071 117.336C179.444 117.442 179.752 117.67 179.993 118.018C180.213 118.337 180.317 118.705 180.305 119.121C180.292 119.537 180.156 119.836 179.894 120.016L178.719 120.828C179.884 122.638 180.715 124.476 181.212 126.342C181.707 128.207 181.477 129.471 180.52 130.133C179.997 130.494 179.332 130.694 178.523 130.734C177.715 130.774 177.108 130.501 176.704 129.916C176.544 129.685 176.351 128.879 176.126 127.499C175.9 126.118 175.43 124.817 174.715 123.597L165.895 129.694C166.258 131.148 166.508 132.393 166.646 133.428C166.783 134.462 166.799 135.646 166.693 136.978C166.586 138.31 166.154 139.557 165.396 140.72C164.638 141.884 163.55 142.956 162.131 143.937C159.538 145.729 156.989 146.446 154.483 146.089C151.976 145.731 149.711 144.462 147.686 142.279L146.232 143.284C145.975 143.461 145.652 143.481 145.262 143.344C144.872 143.205 144.566 142.977 144.346 142.658C144.105 142.31 143.999 141.943 144.028 141.56C144.057 141.175 144.2 140.894 144.456 140.717L145.78 139.801C144.065 137.257 143.163 134.717 143.076 132.183C142.987 129.649 143.529 127.978 144.699 127.169ZM166.463 119.652C165.333 120.432 164.714 121.38 164.608 122.493C164.5 123.607 164.672 125.048 165.124 126.816L173.037 121.347C170.743 118.772 168.552 118.208 166.463 119.652ZM151.726 139.099C153.954 141.332 156.271 141.619 158.674 139.957C159.948 139.077 160.716 138.052 160.979 136.885C161.24 135.717 161.212 134.344 160.891 132.764L151.726 139.099Z",
    fill: "url(#paint15_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.217 73.1274C149.665 74.8912 146.167 74.2523 144.403 71.7008C142.639 69.1489 143.278 65.6509 145.83 63.8871C148.382 62.1234 151.88 62.7623 153.644 65.3138C155.407 67.8653 154.768 71.3637 152.217 73.1274Z",
    fill: "url(#paint16_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.582 168.972C217.684 168.972 220.198 166.457 220.198 163.355C220.198 160.253 217.684 157.739 214.582 157.739C211.48 157.739 208.965 160.253 208.965 163.355C208.965 166.457 211.48 168.972 214.582 168.972Z",
    fill: "url(#paint17_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.974 101.805C112.076 101.805 114.59 99.2907 114.59 96.1888C114.59 93.087 112.076 90.5725 108.974 90.5725C105.872 90.5725 103.357 93.087 103.357 96.1888C103.357 99.2907 105.872 101.805 108.974 101.805Z",
    fill: "url(#paint18_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.532 196.654C177.634 196.654 180.149 194.139 180.149 191.037C180.149 187.935 177.634 185.421 174.532 185.421C171.431 185.421 168.916 187.935 168.916 191.037C168.916 194.139 171.431 196.654 174.532 196.654Z",
    fill: "url(#paint19_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.898 203.657L128.562 74.4214C128.005 72.3242 129.254 70.1726 131.35 69.6156L198.807 51.6933C200.904 51.1363 203.055 52.3846 203.612 54.4813L237.949 183.717C238.506 185.814 237.257 187.966 235.161 188.523L167.704 206.446C165.607 207.003 163.455 205.755 162.898 203.657Z",
    fill: "url(#paint20_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.754 200.157L131.91 76.5397C131.385 74.5619 132.562 72.5329 134.54 72.0075L197.224 55.353C199.202 54.8276 201.231 56.0048 201.757 57.9827L234.6 181.6C235.126 183.578 233.948 185.607 231.971 186.133L169.286 202.786C167.308 203.312 165.279 202.134 164.754 200.157Z",
    fill: "url(#paint21_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.956 182.137C211.272 175.799 215.045 169.295 221.384 167.611C221.644 167.542 221.904 167.482 222.165 167.432C223.415 167.188 224.2 165.942 223.873 164.711L200.826 77.9689C200.499 76.7377 199.2 76.0447 197.993 76.4542C197.742 76.5394 197.486 76.6167 197.226 76.6861C190.888 78.3701 184.385 74.5973 182.701 68.2589C182.699 68.2514 182.697 68.2439 182.695 68.2365C182.381 67.0455 181.184 66.3172 179.994 66.6336L155.098 73.248C153.908 73.5643 153.231 74.7902 153.549 75.9803C153.551 75.9878 153.553 75.9952 153.555 76.0027C155.239 82.3407 151.466 88.8441 145.128 90.5281C144.867 90.5971 144.607 90.6569 144.347 90.7076C143.096 90.9508 142.312 92.1975 142.639 93.4287L165.685 180.171C166.012 181.402 167.312 182.095 168.518 181.686C168.769 181.6 169.025 181.523 169.285 181.454C175.623 179.77 182.127 183.542 183.811 189.881C183.813 189.888 183.814 189.896 183.816 189.903C184.13 191.094 185.327 191.822 186.517 191.506L211.413 184.892C212.603 184.575 213.281 183.35 212.962 182.159C212.961 182.152 212.958 182.144 212.956 182.137Z",
    fill: "url(#paint22_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.255 156.12C198.194 156.12 210.305 144.009 210.305 129.07C210.305 114.13 198.194 102.02 183.255 102.02C168.316 102.02 156.205 114.13 156.205 129.07C156.205 144.009 168.316 156.12 183.255 156.12Z",
    fill: "url(#paint23_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.767 135.142C202.283 134.578 202.596 133.671 202.704 132.416C202.819 131.063 202.77 129.667 202.565 128.229C202.593 128.141 202.615 128.054 202.629 127.968L204.294 125.314C204.446 124.927 204.473 124.546 204.373 124.171C204.264 123.762 204.052 123.444 203.737 123.218C203.421 122.991 203.11 122.919 202.803 123L201.32 123.394C200.28 120.714 198.745 118.649 196.718 117.199C194.69 115.748 192.195 115.417 189.234 116.204C188.179 116.484 187.25 116.858 186.445 117.328C185.64 117.796 184.988 118.39 184.486 119.107C183.985 119.824 183.57 120.491 183.242 121.108C183.239 121.112 183.237 121.117 183.235 121.121C183.235 121.121 178.513 129.26 178.511 129.265C178.463 129.341 178.419 129.416 178.373 129.491L169.819 131.764C169.52 130.226 169.557 128.792 169.932 127.46C170.306 126.129 170.704 125.056 171.125 124.239C171.545 123.422 171.702 122.812 171.595 122.407C171.433 121.797 170.965 121.341 170.193 121.038C169.42 120.735 168.711 120.671 168.065 120.842C167.031 121.117 166.168 121.97 165.473 123.401L149.082 151.653L162.621 202.613L201.767 135.142Z",
    fill: "url(#paint24_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.064 120.842C168.711 120.671 169.42 120.736 170.193 121.038C170.965 121.341 171.433 121.797 171.595 122.407C171.702 122.812 171.545 123.423 171.125 124.239C170.704 125.056 170.306 126.129 169.932 127.46C169.557 128.792 169.52 130.226 169.819 131.764L181.811 128.577C181.914 127.456 182.003 126.592 182.08 125.988C182.156 125.383 182.287 124.573 182.472 123.557C182.657 122.54 182.914 121.723 183.242 121.108C183.57 120.491 183.985 119.824 184.486 119.107C184.988 118.39 185.64 117.796 186.445 117.328C187.249 116.858 188.178 116.484 189.233 116.204C192.195 115.417 194.69 115.748 196.718 117.199C198.746 118.649 200.28 120.715 201.32 123.394L202.804 123C203.11 122.919 203.421 122.991 203.737 123.218C204.052 123.444 204.265 123.762 204.374 124.171C204.473 124.545 204.446 124.926 204.294 125.314C204.141 125.701 203.912 125.936 203.605 126.018L202.224 126.384C202.708 128.482 202.868 130.492 202.704 132.416C202.539 134.339 201.895 135.45 200.77 135.749C200.157 135.912 199.463 135.875 198.688 135.639C197.914 135.403 197.435 134.941 197.252 134.254C197.181 133.983 197.271 133.158 197.527 131.784C197.782 130.408 197.779 129.024 197.519 127.634L187.156 130.388C187.006 131.879 186.82 133.135 186.599 134.156C186.378 135.176 185.993 136.295 185.442 137.513C184.892 138.73 184.063 139.758 182.956 140.596C181.85 141.434 180.463 142.076 178.796 142.519C175.75 143.328 173.108 143.14 170.87 141.956C168.632 140.772 166.93 138.811 165.763 136.072L164.055 136.526C163.753 136.606 163.442 136.515 163.122 136.254C162.802 135.992 162.591 135.674 162.492 135.299C162.383 134.89 162.407 134.509 162.564 134.158C162.722 133.805 162.951 133.589 163.252 133.51L164.808 133.096C164.055 130.121 164.065 127.426 164.84 125.013C165.614 122.597 166.689 121.208 168.064 120.842ZM191.088 121.131C189.761 121.483 188.858 122.165 188.381 123.178C187.903 124.189 187.577 125.603 187.404 127.42L196.701 124.95C195.414 121.751 193.542 120.479 191.088 121.131ZM170.641 134.447C171.982 137.301 174.065 138.355 176.889 137.604C178.385 137.207 179.455 136.503 180.097 135.493C180.739 134.482 181.176 133.18 181.409 131.586L170.641 134.447Z",
    fill: "url(#paint25_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.421 72.5301C190.423 73.3265 187.346 71.542 186.55 68.544C185.754 65.5461 187.538 62.47 190.536 61.6736C193.534 60.8771 196.61 62.6617 197.407 65.6596C198.203 68.6575 196.418 71.7336 193.421 72.5301Z",
    fill: "url(#paint26_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.027 183.964C220.029 184.761 216.953 182.976 216.156 179.978C215.36 176.98 217.145 173.904 220.142 173.108C223.14 172.311 226.216 174.096 227.013 177.094C227.81 180.092 226.025 183.168 223.027 183.964Z",
    fill: "url(#paint27_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.926 85.2192C148.028 85.2192 150.542 82.7047 150.542 79.6029C150.542 76.5011 148.028 73.9866 144.926 73.9866C141.824 73.9866 139.31 76.5011 139.31 79.6029C139.31 82.7047 141.824 85.2192 144.926 85.2192Z",
    fill: "url(#paint28_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.532 196.654C177.634 196.654 180.149 194.139 180.149 191.037C180.149 187.935 177.634 185.42 174.532 185.42C171.43 185.42 168.915 187.935 168.915 191.037C168.915 194.139 171.43 196.654 174.532 196.654Z",
    fill: "url(#paint29_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.765 251.554H71.3816C65.249 251.554 60.2773 246.582 60.2773 240.45V128.72C60.2773 122.587 65.249 117.615 71.3816 117.615H229.764C235.897 117.615 240.869 122.587 240.869 128.72V240.45C240.869 246.582 235.897 251.554 229.765 251.554Z",
    fill: "url(#paint30_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0056 126.24C73.873 126.24 68.9014 131.211 68.9014 137.344V249.074C68.9014 249.846 68.9803 250.598 69.13 251.325C69.857 251.475 70.6098 251.554 71.3814 251.554H229.764C235.897 251.554 240.868 246.582 240.868 240.45V128.72C240.868 127.948 240.789 127.195 240.64 126.468C239.913 126.319 239.159 126.24 238.388 126.24H80.0056Z",
    fill: "url(#paint31_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.765 117.615H229.734V229.314C229.734 235.447 224.762 240.419 218.629 240.419H60.2773V240.45C60.2773 246.582 65.249 251.554 71.3816 251.554H229.764C235.897 251.554 240.869 246.582 240.869 240.45V128.72C240.869 122.587 235.897 117.615 229.765 117.615Z",
    fill: "url(#paint32_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.869 240.03V201.825H202.664L240.869 240.03Z",
    fill: "url(#paint33_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.012 202.216H204.736C201.56 202.216 198.984 199.641 198.984 196.465V172.705C198.984 169.528 201.56 166.953 204.736 166.953H238.012C241.189 166.953 243.764 169.528 243.764 172.705V196.465C243.763 199.641 241.189 202.216 238.012 202.216Z",
    fill: "url(#paint34_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.228 170.881C205.052 170.881 202.477 173.456 202.477 176.632V200.393C202.477 200.888 202.546 201.367 202.664 201.826C203.307 202.075 204.004 202.217 204.736 202.217H238.012C241.189 202.217 243.764 199.642 243.764 196.465V172.705C243.764 172.209 243.694 171.731 243.576 171.272C242.933 171.023 242.236 170.881 241.504 170.881H208.228V170.881Z",
    fill: "url(#paint35_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.763 196.465V196.379L223.692 176.308C221.475 173.929 218.316 172.44 214.808 172.44C208.101 172.44 202.663 177.877 202.663 184.585C202.663 188.093 204.152 191.252 206.531 193.469L215.279 202.216H238.012C241.188 202.216 243.763 199.641 243.763 196.465Z",
    fill: "url(#paint36_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.809 196.73C221.516 196.73 226.953 191.292 226.953 184.585C226.953 177.878 221.516 172.44 214.809 172.44C208.101 172.44 202.664 177.878 202.664 184.585C202.664 191.292 208.101 196.73 214.809 196.73Z",
    fill: "url(#paint37_radial_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.808 195.426C220.796 195.426 225.649 190.572 225.649 184.585C225.649 178.598 220.796 173.744 214.808 173.744C208.821 173.744 203.968 178.598 203.968 184.585C203.968 190.572 208.821 195.426 214.808 195.426Z",
    fill: "url(#paint38_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.241 173.721C221.06 175.356 221.522 177.201 221.522 179.154C221.522 185.861 216.084 191.298 209.377 191.298C207.424 191.298 205.579 190.836 203.944 190.018C205.938 193.997 210.054 196.73 214.808 196.73C221.516 196.73 226.953 191.292 226.953 184.585C226.953 179.83 224.221 175.715 220.241 173.721Z",
    fill: "url(#paint39_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.02 179.387C223.02 182.504 219.344 185.03 214.809 185.03C210.273 185.03 206.597 182.504 206.597 179.387C206.597 176.271 210.273 173.744 214.809 173.744C219.344 173.744 223.02 176.27 223.02 179.387Z",
    fill: "url(#paint40_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3816 251.554H179.37L123.777 195.961C123.354 195.111 122.479 194.526 121.465 194.526H111.99H93.7314H74.5533H60.2773V240.45C60.2773 246.583 65.249 251.554 71.3816 251.554Z",
    fill: "url(#paint41_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.465 263H46.8198C45.3932 263 44.2363 261.843 44.2363 260.417V248.465C44.2363 247.039 45.3932 245.882 46.8198 245.882H121.465C122.892 245.882 124.049 247.039 124.049 248.465V260.417C124.049 261.844 122.893 263 121.465 263Z",
    fill: "url(#paint42_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.99 263H56.2952C55.0561 263 54.0518 261.996 54.0518 260.757V248.125C54.0518 246.886 55.0561 245.881 56.2952 245.881H111.99C113.229 245.881 114.233 246.886 114.233 248.125V260.757C114.233 261.996 113.229 263 111.99 263Z",
    fill: "url(#paint43_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7323 263H74.5538C73.8068 263 73.2012 262.394 73.2012 261.647V247.234C73.2012 246.487 73.8068 245.882 74.5538 245.882H93.7323C94.4793 245.882 95.085 246.487 95.085 247.234V261.647C95.085 262.394 94.4793 263 93.7323 263Z",
    fill: "url(#paint44_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0727 247.964C47.6461 247.964 46.4893 249.121 46.4893 250.548V262.5C46.4893 262.665 46.5063 262.827 46.5362 262.984C46.6293 262.994 46.7241 263 46.8201 263H121.466C122.892 263 124.049 261.843 124.049 260.417V248.465C124.049 248.299 124.032 248.138 124.002 247.98C123.909 247.97 123.814 247.964 123.719 247.964H49.0727Z",
    fill: "url(#paint45_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.465 245.882H46.8198C45.3932 245.882 44.2363 244.725 44.2363 243.298V231.347C44.2363 229.92 45.3932 228.763 46.8198 228.763H121.465C122.892 228.763 124.049 229.92 124.049 231.347V243.298C124.049 244.725 122.893 245.882 121.465 245.882Z",
    fill: "url(#paint46_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.99 245.882H56.2952C55.0561 245.882 54.0518 244.877 54.0518 243.638V231.006C54.0518 229.768 55.0561 228.763 56.2952 228.763H111.99C113.229 228.763 114.233 229.767 114.233 231.006V243.638C114.233 244.877 113.229 245.882 111.99 245.882Z",
    fill: "url(#paint47_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7323 245.882H74.5538C73.8068 245.882 73.2012 245.276 73.2012 244.529V230.116C73.2012 229.369 73.8068 228.763 74.5538 228.763H93.7323C94.4793 228.763 95.085 229.369 95.085 230.116V244.529C95.085 245.276 94.4793 245.882 93.7323 245.882Z",
    fill: "url(#paint48_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0727 230.846C47.6461 230.846 46.4893 232.003 46.4893 233.429V245.381C46.4893 245.547 46.5063 245.708 46.5362 245.865C46.6293 245.875 46.7241 245.881 46.8201 245.881H121.466C122.892 245.881 124.049 244.724 124.049 243.298V231.346C124.049 231.18 124.032 231.019 124.002 230.862C123.909 230.852 123.814 230.846 123.719 230.846H49.0727Z",
    fill: "url(#paint49_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.465 228.763H46.8198C45.3932 228.763 44.2363 227.606 44.2363 226.179V214.228C44.2363 212.801 45.3932 211.644 46.8198 211.644H121.465C122.892 211.644 124.049 212.801 124.049 214.228V226.179C124.049 227.606 122.893 228.763 121.465 228.763Z",
    fill: "url(#paint50_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.99 228.763H56.2952C55.0561 228.763 54.0518 227.759 54.0518 226.519V213.888C54.0518 212.649 55.0561 211.644 56.2952 211.644H111.99C113.229 211.644 114.233 212.648 114.233 213.888V226.519C114.233 227.759 113.229 228.763 111.99 228.763Z",
    fill: "url(#paint51_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7323 228.763H74.5538C73.8068 228.763 73.2012 228.157 73.2012 227.41V212.997C73.2012 212.25 73.8068 211.644 74.5538 211.644H93.7323C94.4793 211.644 95.085 212.25 95.085 212.997V227.41C95.085 228.157 94.4793 228.763 93.7323 228.763Z",
    fill: "url(#paint52_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0727 213.727C47.6461 213.727 46.4893 214.884 46.4893 216.311V228.262C46.4893 228.428 46.5063 228.589 46.5362 228.746C46.6293 228.757 46.7241 228.762 46.8201 228.762H121.466C122.892 228.762 124.049 227.606 124.049 226.179V214.228C124.049 214.062 124.032 213.9 124.002 213.743C123.909 213.733 123.814 213.727 123.719 213.727H49.0727Z",
    fill: "url(#paint53_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.465 211.644H46.8198C45.3932 211.644 44.2363 210.488 44.2363 209.061V197.11C44.2363 195.683 45.3932 194.526 46.8198 194.526H121.465C122.892 194.526 124.049 195.683 124.049 197.11V209.061C124.049 210.488 122.893 211.644 121.465 211.644Z",
    fill: "url(#paint54_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.99 211.644H56.2952C55.0561 211.644 54.0518 210.64 54.0518 209.401V196.769C54.0518 195.53 55.0561 194.526 56.2952 194.526H111.99C113.229 194.526 114.233 195.53 114.233 196.769V209.401C114.233 210.64 113.229 211.644 111.99 211.644Z",
    fill: "url(#paint55_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7323 211.644H74.5538C73.8068 211.644 73.2012 211.039 73.2012 210.292V195.879C73.2012 195.132 73.8068 194.526 74.5538 194.526H93.7323C94.4793 194.526 95.085 195.132 95.085 195.879V210.292C95.085 211.039 94.4793 211.644 93.7323 211.644Z",
    fill: "url(#paint56_linear_2924_189316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0727 196.609C47.6461 196.609 46.4893 197.765 46.4893 199.192V211.144C46.4893 211.309 46.5063 211.471 46.5362 211.628C46.6293 211.638 46.7241 211.644 46.8201 211.644H121.466C122.892 211.644 124.049 210.487 124.049 209.061V197.11C124.049 196.944 124.032 196.782 124.002 196.625C123.909 196.615 123.814 196.609 123.719 196.609H49.0727V196.609Z",
    fill: "url(#paint57_linear_2924_189316)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2924_189316",
    x1: 146.654,
    y1: 118.053,
    x2: 120.48,
    y2: 222.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2924_189316",
    x1: 139.128,
    y1: 151.599,
    x2: 172.633,
    y2: -26.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2924_189316",
    x1: 146.417,
    y1: 122.741,
    x2: 125.362,
    y2: 190.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2924_189316",
    x1: 150.768,
    y1: 160.723,
    x2: 115.384,
    y2: 70.3345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2924_189316",
    x1: 149.167,
    y1: 160.088,
    x2: 117.39,
    y2: 106.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2924_189316",
    x1: 141.007,
    y1: 134.303,
    x2: 150.339,
    y2: 159.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2924_189316",
    x1: 108.72,
    y1: 81.7418,
    x2: 110.672,
    y2: 97.1917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2924_189316",
    x1: 202.454,
    y1: 148.843,
    x2: 204.406,
    y2: 164.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2924_189316",
    x1: 80.3863,
    y1: 121.321,
    x2: 82.3378,
    y2: 136.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2924_189316",
    x1: 174.12,
    y1: 188.422,
    x2: 176.072,
    y2: 203.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2924_189316",
    x1: 173.04,
    y1: 113.012,
    x2: 112.976,
    y2: 202.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2924_189316",
    x1: 154.61,
    y1: 142.066,
    x2: 246.318,
    y2: -14.1935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2924_189316",
    x1: 171.232,
    y1: 117.347,
    x2: 128.617,
    y2: 173.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2924_189316",
    x1: 162.49,
    y1: 154.595,
    x2: 159.717,
    y2: 57.4933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2924_189316",
    x1: 161.196,
    y1: 153.456,
    x2: 149.484,
    y2: 91.9473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2924_189316",
    x1: 162.227,
    y1: 126.41,
    x2: 162.554,
    y2: 153.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2924_189316",
    x1: 149.585,
    y1: 65.9848,
    x2: 146.2,
    y2: 81.1975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2924_189316",
    x1: 215.189,
    y1: 160.88,
    x2: 211.805,
    y2: 176.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2924_189316",
    x1: 109.516,
    y1: 93.6862,
    x2: 106.131,
    y2: 108.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2924_189316",
    x1: 175.121,
    y1: 188.581,
    x2: 171.736,
    y2: 203.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2924_189316",
    x1: 199.523,
    y1: 117.102,
    x2: 112.618,
    y2: 181.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2924_189316",
    x1: 172.351,
    y1: 138.207,
    x2: 311.515,
    y2: 22.1937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2924_189316",
    x1: 196.356,
    y1: 120.571,
    x2: 137.188,
    y2: 159.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2924_189316",
    x1: 175.527,
    y1: 152.663,
    x2: 205.77,
    y2: 60.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2924_189316",
    x1: 174.696,
    y1: 151.153,
    x2: 184.485,
    y2: 89.3111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2924_189316",
    x1: 184.816,
    y1: 126.052,
    x2: 176.078,
    y2: 151.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2924_189316",
    x1: 193.362,
    y1: 64.9142,
    x2: 185.03,
    y2: 78.0842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2924_189316",
    x1: 222.992,
    y1: 176.406,
    x2: 214.66,
    y2: 189.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2924_189316",
    x1: 146.286,
    y1: 77.4253,
    x2: 137.954,
    y2: 90.5949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2924_189316",
    x1: 175.914,
    y1: 188.917,
    x2: 167.583,
    y2: 202.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2924_189316",
    x1: 101.757,
    y1: 105.347,
    x2: 204.199,
    y2: 271.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C6239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2924_189316",
    x1: 165.789,
    y1: 198.61,
    x2: 53.9928,
    y2: 99.0213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C59B6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1809,
    stopColor: "#C69D71",
    stopOpacity: 0.181
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3458,
    stopColor: "#CBA57C",
    stopOpacity: 0.346
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5044,
    stopColor: "#D2B28E",
    stopOpacity: 0.504
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6593,
    stopColor: "#DDC4A8",
    stopOpacity: 0.659
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8113,
    stopColor: "#EADBCA",
    stopOpacity: 0.811
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9593,
    stopColor: "#FAF6F2",
    stopOpacity: 0.959
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2924_189316",
    x1: 129.755,
    y1: 163.767,
    x2: 259.896,
    y2: 293.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C6239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2924_189316",
    x1: 239.456,
    y1: 231.105,
    x2: 218.563,
    y2: 196.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C6239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2924_189316",
    x1: 207.567,
    y1: 164.923,
    x2: 236.666,
    y2: 206.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C6239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2924_189316",
    x1: 225.234,
    y1: 188.87,
    x2: 201.489,
    y2: 162.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C59B6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1809,
    stopColor: "#C69D71",
    stopOpacity: 0.181
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3458,
    stopColor: "#CBA57C",
    stopOpacity: 0.346
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5044,
    stopColor: "#D2B28E",
    stopOpacity: 0.504
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6593,
    stopColor: "#DDC4A8",
    stopOpacity: 0.659
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8113,
    stopColor: "#EADBCA",
    stopOpacity: 0.811
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9593,
    stopColor: "#FAF6F2",
    stopOpacity: 0.959
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2924_189316",
    x1: 238.11,
    y1: 207.887,
    x2: 214.785,
    y2: 184.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C6239"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2924_189316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(211.311 179.921) scale(15.1322 15.1322)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4169,
    stopColor: "#FFD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6278,
    stopColor: "#FFCF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7926,
    stopColor: "#FFC237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9326,
    stopColor: "#FFAF2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2924_189316",
    x1: 216.918,
    y1: 186.695,
    x2: 202.39,
    y2: 172.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2924_189316",
    x1: 219.967,
    y1: 185.041,
    x2: 242.591,
    y2: 165.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2924_189316",
    x1: 214.809,
    y1: 180.85,
    x2: 214.809,
    y2: 169.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2924_189316",
    x1: 161.808,
    y1: 251.697,
    x2: 99.1573,
    y2: 224.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C6239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2924_189316",
    x1: 84.1426,
    y1: 246.234,
    x2: 84.1426,
    y2: 268.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2924_189316",
    x1: 84.1429,
    y1: 246.556,
    x2: 84.1429,
    y2: 283.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2924_189316",
    x1: 84.1433,
    y1: 246.556,
    x2: 84.1433,
    y2: 283.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2924_189316",
    x1: 84.0507,
    y1: 252.536,
    x2: 75.2007,
    y2: 231.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2924_189316",
    x1: 84.1426,
    y1: 229.116,
    x2: 84.1426,
    y2: 251.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2924_189316",
    x1: 84.1429,
    y1: 229.437,
    x2: 84.1429,
    y2: 266.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2924_189316",
    x1: 84.1433,
    y1: 229.437,
    x2: 84.1433,
    y2: 266.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2924_189316",
    x1: 84.0507,
    y1: 235.417,
    x2: 75.2007,
    y2: 214.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2924_189316",
    x1: 84.1426,
    y1: 211.997,
    x2: 84.1426,
    y2: 234.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2924_189316",
    x1: 84.1429,
    y1: 212.319,
    x2: 84.1429,
    y2: 249.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2924_189316",
    x1: 84.1433,
    y1: 212.319,
    x2: 84.1433,
    y2: 249.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2924_189316",
    x1: 84.0507,
    y1: 218.299,
    x2: 75.2007,
    y2: 196.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2924_189316",
    x1: 84.1426,
    y1: 194.879,
    x2: 84.1426,
    y2: 217.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2924_189316",
    x1: 84.1429,
    y1: 195.201,
    x2: 84.1429,
    y2: 232.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2924_189316",
    x1: 84.1433,
    y1: 195.201,
    x2: 84.1433,
    y2: 232.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2924_189316",
    x1: 84.0507,
    y1: 201.18,
    x2: 75.2007,
    y2: 179.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2924_189316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 212,
    fill: "white",
    transform: "translate(38 51)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherDashboardTop);
export default __webpack_public_path__ + "static/media/teacher-dashboard-top.4ab428bed7b7abbda6a1b17aa8305a1d.svg";
export { ForwardRef as ReactComponent };